(function ($) {

    $(document).ready(function () {

        if ($('#search_results_form').length > 0) {
            const { __, _x, _n, _nx } = wp.i18n;

            const flightsSearchModule = $('#search_results_form');
            const flightsSearchModuleTrigger = $('#search_results_form #flights_search_module_trigger');
            const flightSearchForm = flightsSearchModule.find("#flights_form");

            if (flightsSearchModule.length > 0) {

                //mobile
                changePlaceholder();

                flightsSearchModuleTrigger.click(function () {

                    $(this).find('.fa-chevron-down').toggleClass('active');
                    flightsSearchModule.find('#flights_search_form_wrap').slideToggle();
                });

                //on window resize, show/hide items
                $(window).resize(function () {
                    const winWidth = window.innerWidth;
                    const chevronDown = flightsSearchModuleTrigger.find('.fa-chevron-down');

                    if (winWidth > 767) {

                        flightsSearchModule.find('#flights_search_form_wrap').show();

                    } else {

                        if (!chevronDown.hasClass('active')) {
                            flightsSearchModule.find('#flights_search_form_wrap').hide();
                        }
                    }

                    changePlaceholder();
                });

                /**
                 * Destinations List Array
                 */
                var data_dest = flightSearchForm.attr('data-dest');
                if (data_dest !== "" && typeof data_dest !== 'undefined') {
                    data_dest = JSON.parse(data_dest);

                    const destinationsList = [];

                    $.each(data_dest, function (index, value) {
                        destinationsList.push(value);
                    });

                    flightSearchForm.find("#from-destination").autocomplete({
                        source: destinationsList,
                        change: function (event, ui) {
                            if (ui.item == null) {
                                event.currentTarget.value = '';
                                event.currentTarget.focus();
                            }
                        }
                    });
                    flightSearchForm.find("#to-destination").autocomplete({
                        source: destinationsList,
                        change: function (event, ui) {
                            if (ui.item == null) {
                                event.currentTarget.value = '';
                                event.currentTarget.focus();
                            }
                        }
                    });
                }

                //regex the flight number
                $.validator.addMethod(
                    "regexFlightNo",
                    function (value, element) {
                        return this.optional(element) || /^([a-zA-Z0-9]+)$/i.test(value);
                    },
                    __('Flight number must contain only numbers and letters', 'sofia-airport')
                );

                //flight date - choose a date
                const flight_search_date = flightSearchForm.find("#flight_search_date");
                flight_search_date.datepicker({
                    changeMonth: true,
                    changeYear: true,
                    dateFormat: "dd/mm/yy",
                    minDate: "-6M",
                    maxDate: "+1Y",
                    firstDay: 1
                });

                //regex the flight date
                $.validator.addMethod(
                    "regexDateFormat",
                    function (value, element, regexp) {
                        const re = new RegExp(regexp);
                        return this.optional(element) || re.test(value);
                    },
                    __('Wrong date format', 'sofia-airport')
                );

                flightSearchForm.validate({
                    rules: {
                        flight_no: {
                            require_from_group: [1, ".search-group"],
                            minlength: 2,
                            maxlength: 7,
                            regexFlightNo: true
                        },
                        arr_destination: {
                            require_from_group: [1, ".search-group"]
                        },
                        dep_destination: {
                            require_from_group: [1, ".search-group"]
                        },
                        flight_search_date: {
                            regexDateFormat: /^(?=\d)(?:(?:31(?!.(?:0?[2469]|11))|(?:30|29)(?!.0?2)|29(?=.0?2.(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00)))(?:\x20|$))|(?:2[0-8]|1\d|0?[1-9]))([-.\/])(?:1[012]|0?[1-9])\1(?:1[6-9]|[2-9]\d)?\d\d(?:(?=\x20\d)\x20|$))?(((0?[1-9]|1[012])(:[0-5]\d){0,2}(\x20[AP]M))|([01]\d|2[0-3])(:[0-5]\d){1,2})?$/
                        }
                    },
                    submitHandler: function (form) {
                        form.submit();
                    }
                });

                $.extend($.validator.messages, {
                    required: __('Flight number is required', 'sofia-airport'),
                    minlength: __('Wrong flight number', 'sofia-airport'),
                    maxlength: __('Wrong flight number', 'sofia-airport'),
                    require_from_group: __('At least one field is required', 'sofia-airport'),
                });
            }

            function changePlaceholder() {
                const winWidth = window.innerWidth;
                const inputFrom = $('#from-destination');
                const inputTo = $('#to-destination');
                let textFrom = __('From', 'sofia-airport');
                let textTo = __('To', 'sofia-airport');

                if (winWidth > 767) {
                    textFrom = textTo = __('City, Airport', 'sofia-airport');
                }

                inputFrom.attr('placeholder', textFrom);
                inputTo.attr('placeholder', textTo);
            }
        }

    });
})(jQuery);